const taxes = {
  vat: { value: 'VAT', label: 'VAT' },
  tax: { value: 'Tax', label: 'Tax' },
};

export default taxes;
